import GlobalEmitter from '~/glxp/utils/emitter'

const fullHeight = ref(0)

function getHeight() {
  const div = document.createElement('div')
  div.style.height = '100vh'
  document.body.appendChild(div)
  const { height } = div.getBoundingClientRect()
  fullHeight.value = height
  div.remove()
}

GlobalEmitter.on('debouncedResize', getHeight)
GlobalEmitter.off('debouncedResize', getHeight)

export function useFullHeight() {
  getHeight()

  return fullHeight
}
